
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { ErrorBase } from 'base-models';
import { ErrorcontrolService } from 'basecomponents';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SortHelper } from 'shtools';
import { Site } from 'solar-bo';
import { SolarService } from '../../services/solarservice.service';

@Component({
  selector: 'app-site-filter2',
  templateUrl: './site-filter2.component.html',
  styleUrls: ['./site-filter2.component.scss']
})
export class SiteFilter2Component implements OnInit, OnDestroy {

  @Input() myplaceholder: string = "Placeholder";
  private _list: Site[] = [];
  @Input()  
  public get list(): Site[] {
    return this._list;
  }
  public set list(value: Site[]) {
    this._list = value;
    this.configSiteAutoComplete();
  }
  @Input() includeall: boolean = true;
  @Input() includeall_text: string = "All";
  @Input() selectfirst: boolean = false;
  /**
   * id fo selected item
   */
  @Input() selecteditem: any = -1;
  @Input() automaticLoad: boolean = true;

  @Output() onFilterChange: EventEmitter<any> = new EventEmitter();
  @Output() onSiteSelected: EventEmitter<any> = new EventEmitter();
  //@ViewChild('filterby', { static: false }) filterbysite: MatSelect;
  //@ViewChild('findSiteInput') findSiteInput: ElementRef;

  constructor(public baseService: SolarService

  ) {

  }
  ngOnInit() {
    if (this.automaticLoad) {
      this.getList();
    }
    else{
      //this.configSiteAutoComplete();
    }

  }

  ngOnDestroy() {

  }

  getSelectBy() {
    /* let returnvalue:any= this.filterbyproperty.selected;//in this case we expect always one item
    return returnvalue.value; */
    return this.selecteditem;
  }



  changeitem(event) {
    console.log("changeitem", event.value);
    this.selecteditem = event.value;
    this.onFilterChange.emit(this.selecteditem);
    this.notifySelectedItem(event.value);
  }

  notifySelectedItem(id) {
    let site = this.list.find(item => item.id == id);
    if (site) {
      this.onSiteSelected.emit(site);
    }
  }

  selectItemById(id_site) {
    this.selecteditem = id_site;
  }

  getList(): void {
    this.baseService.sitesGetAll()
      .subscribe(
        elements => this.handleresult(elements)
        , err => this.handleError(err)
      );
  }

  handleresult(listresult: Site[]) {

    if (this.includeall == true) {

    } else {
      let index = listresult.findIndex(d => d.id === '-1');
      if (index != -1) {
        listresult.splice(index, 1);
      }

    }
    listresult = listresult.sort((a, b) => SortHelper.sortByStringLocale(a.name, b.name));
    this.list = listresult;

    if (this.selectfirst) {
      if (listresult.length > 0) {
        this.selecteditem = listresult[0].id;
      }
    } else if (this.selecteditem != '-1') {
      this.onFilterChange.emit(this.selecteditem);
      this.notifySelectedItem(this.selecteditem);
    }
    this.configSiteAutoComplete();
  }

  handleError<T>(err: any) {
    let errbase: ErrorBase = ErrorcontrolService.getListhandleError(err);
  }

  findSiteInputControl_filteredOptions: Observable<Site[]>;
  findSiteInputControl = new FormControl();
  private configSiteAutoComplete() {
    let sites=[];
    if (this.list!=null){
      sites=this.list.slice();
    }
    this.findSiteInputControl_filteredOptions = this.findSiteInputControl.valueChanges
      .pipe(
        startWith(''),
        map(value => value ? this.siteAutoComplete_siteFilter(value): sites  )
      );
  }
  private siteAutoComplete_siteFilter(value) {
    if (value == '') {
      return;
    }
    else if (typeof (value) !== "string") {
      return;
    }
    const filterValue = SortHelper.normalizeValue(value);

    //let newlist = this.list.filter(option => SortHelper.normalizeValue(option.name).includes(filterValue));
    let newlist = this.list.filter(option => this.filter(option,filterValue));
    newlist.sort((a, b) => SortHelper.sortByStringLocale(a.name, b.name));
    return newlist;

  }

  private filter(option, filterValue){
    let siteName=SortHelper.normalizeValue(option.name);
    let zone=SortHelper.normalizeValue(option.info.zone);
    return siteName.includes(filterValue) 
    || zone.includes(filterValue) ;
  }



  /**
 * Method linked to the mat-autocomplete `[displayWith]` input.
 * This is how result name is printed in the input box.
 */
  siteAutoComplete_displayFn(result: Site): string | undefined {
    return result ? result.name : undefined;
  }

  siteAutoComplete_optionSelected($event: MatAutocompleteSelectedEvent) {
    console.log($event);
    let site: Site = $event.option.value;
    if (site) {
      this.onSiteSelected.emit(site);
    }
  }

  clearInput(){
    console.log("clear input");
    this.findSiteInputControl.setValue('');
    this.onSiteSelected.emit(null);
    //this.findSiteInput.nativeElement.focus();
  }

}

